<template>

  <div style="overflow: hidden;">
    <div class="card">
      <div class="card-body">
        <highcharts
          :options="chartOptions">
          </highcharts>
      </div>
    </div>
  </div>

</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
  name: 'JobReport',
  components: {
    highcharts: Chart
  },
  props: {
    grid: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    chartOptions () {
      return {
        chart: {
          type: 'column'
        },
        lang: {
          noData: this.$t('No data to display')
        },
        title: {
          text: this.$t('Pipeline conversions')
        },
        xAxis: {
          // categories: ['Candidatura <b>22%</b>', 'Triagem <b>40%</b>']
          categories: this.grid.map(v => v.name)
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('Candidates')
          },
          stackLabels: {
            enabled: true
          }
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>-<br/><span>Entraram</span>:<b>{point.total}</b><br/>',
          pointFormat: ` <span style="color:{series.color}">{series.name}</span>:<b>{point.y}</b> ({point.percentage:.1f}%)<br/>`,
          shared: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            stacking: 'stream',
            dataLabels: {
              enabled: true,
              color: '#5cb84a',
              verticalAlign: 'bottom',
              align: 'right',
              x: 45,
              formatter: function () {
                if (this.point.series.userOptions.kind === 'remained') {
                  return null // this.point.options.y
                } else {
                  const perc = this.point.options.y / this.point.total * 100
                  return `${perc.toFixed(1)}%`
                }
              }
            }
          }
        },
        /* series: [{
          name: 'Permaneceram',
          color: 'black',
          data: [5, 3, 4, 7, 2]
        }, {
          name: 'Avançaram',
          color: 'green',
          data: [2, 2, 3, 2, 1]
        }] */
        series: [{
          kind: 'remained',
          name: this.$t('Remained'),
          color: '#434348',
          data: this.grid.map(v => v.total_movements - v.total_moved)
        }, {
          kind: 'proceeded',
          name: this.$t('Proceeded'),
          color: '#5cb84a',
          data: this.grid.map(v => v.total_moved)
        }]
      }
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobReport/JobReportPipelineConversion.vue